import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SLIDES = [
  `${process.env.REACT_APP_BACKEND_URL}/api/files/zalta/uploads/products/4258cf49-90a2-4d06-a073-5c74f468a8cd.jpg`,
  `${process.env.REACT_APP_BACKEND_URL}/api/files/zalta/uploads/products/51c38dd5-93d5-4068-8dbe-25bc92b87a77.jpg`,
  `${process.env.REACT_APP_BACKEND_URL}/api/files/zalta/uploads/products/ddfc0fda-1ec3-4bd4-a9b6-69612c7e5167.jpg`,
];

export const Hero = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);

  const prev = () => setIndex((i) => (i - 1 + SLIDES.length) % SLIDES.length);
  const next = () => setIndex((i) => (i + 1) % SLIDES.length);

  return (
    <section data-testid="hero-section" className="relative bg-[#F5EFFA] overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 lg:px-10 pt-[70px] pb-6 sm:pb-12">
        <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_80px_-30px_rgba(90,40,130,0.35)]">
          {SLIDES.map((src, i) => (
            <img
              key={src}
              src={src}
              alt={`ZALTA banner ${i + 1}`}
              className={`w-full h-auto block transition-opacity duration-700 ease-out ${
                i === index ? "relative opacity-100" : "absolute inset-0 opacity-0 pointer-events-none"
              }`}
            />
          ))}

          <button
            data-testid="hero-prev-btn"
            onClick={prev}
            aria-label="Previous slide"
            className="absolute left-2 sm:left-5 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-11 sm:h-11 rounded-full bg-white/85 backdrop-blur border border-[#8E5A9E]/30 text-[#74427F] flex items-center justify-center hover:bg-[#8E5A9E] hover:text-white hover:border-[#8E5A9E] shadow-lg transition-colors duration-300 active:scale-90"
          >
            <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button
            data-testid="hero-next-btn"
            onClick={next}
            aria-label="Next slide"
            className="absolute right-2 sm:right-5 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-11 sm:h-11 rounded-full bg-white/85 backdrop-blur border border-[#8E5A9E]/30 text-[#74427F] flex items-center justify-center hover:bg-[#8E5A9E] hover:text-white hover:border-[#8E5A9E] shadow-lg transition-colors duration-300 active:scale-90"
          >
            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>

          <div className="absolute bottom-2 sm:bottom-4 left-1/2 -translate-x-1/2 flex gap-2 sm:gap-2.5 bg-white/70 backdrop-blur px-2.5 sm:px-3.5 py-1.5 sm:py-2 rounded-full shadow">
            {SLIDES.map((_, i) => (
              <button
                key={i}
                data-testid={`hero-dot-${i}`}
                onClick={() => setIndex(i)}
                aria-label={`Slide ${i + 1}`}
                className={`h-2 sm:h-2.5 rounded-full transition-[width,background-color] duration-400 ${
                  i === index ? "w-6 sm:w-7 bg-[#8E5A9E]" : "w-2 sm:w-2.5 bg-[#8E5A9E]/30 hover:bg-[#8E5A9E]/60"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
